import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=689537cc"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3555460120/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689537cc')) {
      api.createRecord('689537cc', component.options)
    } else {
      api.reload('689537cc', component.options)
    }
    module.hot.accept("./ProductFilter.vue?vue&type=template&id=689537cc", function () {
      api.rerender('689537cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductFilter.vue"
export default component.exports